export default __webpack_public_path__ + "static/mobileVector-4d345354bc3b93559151c8bc13982455.svg";